import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IntellioHttpResponse, MeterCollar } from '@intellio/shared/models';
import { config, Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root',
})
export class MeterCollarService extends BaseService {
  constructor(
    protected client: HttpClient,
    protected configService: AppConfigService,
    protected authService: AuthService
  ) {
    super(client, configService, authService);
  }

  getMeterCollars(): Observable<IntellioHttpResponse<MeterCollar[]>> {
    const url = '/api/metercollar';
    return this.get<MeterCollar[]>(url);
  }
}
